import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component to set page title and meta tags
 * @param {string} title - The title to set for the page
 * @param {string} [description] - Optional meta description
 * @param {string} [suffix] - Optional suffix to append to the title
 */
const PageTitle = ({ title, description, suffix = ' - MedHive' }) => {
  const fullTitle = suffix ? `${title}${suffix}` : title;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
    </Helmet>
  );
};

export default PageTitle;
